module.exports = __webpack_public_path__ + "img/logo.1cff6d96.png";